import { useTranslation } from 'react-i18next';

export const keyPrefix = 'create_role';
export const useCreateRoleTranslation = () => useTranslation('features', { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    add_button: 'Добавить',
    toast_success: 'Роль успешно создана',
    toast_error: 'Не удалось создать роль',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    add_button: 'Add',
    toast_success: 'Role created successfully',
    toast_error: 'Failed to create role',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    add_button: 'Crear',
    toast_success: 'Rol creado con éxito',
    toast_error: 'Error al crear el rol',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    add_button: 'Adicionar',
    toast_success: 'Função criada com sucesso',
    toast_error: 'Falha ao criar função',
  },
}) as Record<string, unknown>;
